// import axios from 'axios';
// import httpClient, { setAuthTokens, setStoredUser, clearAuthTokens, getRefreshToken } from './httpClient';
// import {
//   AdminLoginRequest,
//   AdminLoginResponse,
//   AdminLoginResult,
//   LogoutRequest,
//   LogoutResponse,
//   RefreshTokenRequest,
//   RefreshTokenResponse,
//   RefreshTokenResult,
// } from '../types/authModel';

// /**
//  * Logs in an admin user via POST /auth/admin-login.
//  * On success, persists the access token, refresh token, and user to
//  * local storage and returns the result. On failure, throws an Error
//  * with the API's message (works whether the API responds with a 4xx
//  * status or a 200 with `success: false`).
//  */
// export const adminLogin = async (email: string, password: string): Promise<AdminLoginResult> => {
//   const payload: AdminLoginRequest = { email, password };

//   try {
//     const { data } = await httpClient.post<AdminLoginResponse>('/auth/admin-login', payload);

//     if (!data.success || !data.result) {
//       throw new Error(data.message || 'Login failed. Please try again.');
//     }

//     const { token, refreshToken, user } = data.result;
//     setAuthTokens(token, refreshToken);
//     setStoredUser(user);

//     return data.result;
//   } catch (err) {
//     if (axios.isAxiosError<AdminLoginResponse>(err)) {
//       throw new Error(err.response?.data?.message || 'Login failed. Please try again.');
//     }
//     throw err;
//   }
// };

// /**
//  * Logs out the current user via POST /auth/logout (invalidates the refresh
//  * token server-side) and clears local auth storage regardless of the API
//  * outcome, so the user is never stuck in a logged-in-looking state.
//  */
// export const logout = async (): Promise<void> => {
//   const refreshToken = getRefreshToken();

//   try {
//     if (refreshToken) {
//       const payload: LogoutRequest = { refreshToken };
//       await httpClient.post<LogoutResponse>('/auth/logout', payload);
//     }
//   } finally {
//     clearAuthTokens();
//   }
// };

// /**
//  * Manually exchanges a refresh token for a new token pair via
//  * POST /auth/refresh-token. You normally won't call this yourself —
//  * httpClient's response interceptor already does this automatically
//  * whenever a request comes back with a 401.
//  */
// export const refreshAuthToken = async (refreshToken: string): Promise<RefreshTokenResult> => {
//   const payload: RefreshTokenRequest = { refreshToken };

//   try {
//     const { data } = await httpClient.post<RefreshTokenResponse>('/auth/refresh-token', payload);

//     if (!data.success || !data.result) {
//       throw new Error(data.message || 'Invalid or expired refresh token.');
//     }

//     return data.result;
//   } catch (err) {
//     if (axios.isAxiosError<RefreshTokenResponse>(err)) {
//       throw new Error(err.response?.data?.message || 'Invalid or expired refresh token.');
//     }
//     throw err;
//   }
// };









import axios from 'axios';
import httpClient, { setAuthTokens, setStoredUser, clearAuthTokens, getRefreshToken } from './httpClient';
import {
  AdminLoginRequest,
  AdminLoginResponse,
  AdminLoginResult,
  BrandRegisterRequest,
  BrandRegisterResponse,
  BrandRegisterResult,
  LogoutRequest,
  LogoutResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  RefreshTokenResult,
} from '../types/authModel';

/**
 * Logs in an admin user via POST /auth/admin-login.
 * On success, persists the access token, refresh token, and user to
 * local storage and returns the result. On failure, throws an Error
 * with the API's message (works whether the API responds with a 4xx
 * status or a 200 with `success: false`).
 */
export const adminLogin = async (email: string, password: string): Promise<AdminLoginResult> => {
  const payload: AdminLoginRequest = { email, password };

  try {
    const { data } = await httpClient.post<AdminLoginResponse>('/auth/admin-login', payload);

    if (!data.success || !data.result) {
      throw new Error(data.message || 'Login failed. Please try again.');
    }

    const { token, refreshToken, user } = data.result;
    setAuthTokens(token, refreshToken);
    setStoredUser(user);

    return data.result;
  } catch (err) {
    if (axios.isAxiosError<AdminLoginResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Login failed. Please try again.');
    }
    throw err;
  }
};

/**
 * Registers a new brand/company via POST /brand/register.
 * Registration issues no tokens — user must log in separately after
 * verifying their email, so this doesn't touch local storage. GST is
 * optional; omit it from the payload entirely when blank rather than
 * sending an empty string.
 */
export const brandRegister = async (payload: BrandRegisterRequest): Promise<BrandRegisterResult> => {
  try {
    const { data } = await httpClient.post<BrandRegisterResponse>('/brand/register', payload);

    if (!data.success || !data.result) {
      throw new Error(data.message || 'Registration failed. Please try again.');
    }

    return data.result;
  } catch (err) {
    if (axios.isAxiosError<BrandRegisterResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Registration failed. Please try again.');
    }
    throw err;
  }
};

/**
 * Logs out the current user via POST /auth/logout (invalidates the refresh
 * token server-side) and clears local auth storage regardless of the API
 * outcome, so the user is never stuck in a logged-in-looking state.
 */
export const logout = async (): Promise<void> => {
  const refreshToken = getRefreshToken();

  try {
    if (refreshToken) {
      const payload: LogoutRequest = { refreshToken };
      await httpClient.post<LogoutResponse>('/auth/logout', payload);
    }
  } finally {
    clearAuthTokens();
  }
};

/**
 * Manually exchanges a refresh token for a new token pair via
 * POST /auth/refresh-token. You normally won't call this yourself —
 * httpClient's response interceptor already does this automatically
 * whenever a request comes back with a 401.
 */
export const refreshAuthToken = async (refreshToken: string): Promise<RefreshTokenResult> => {
  const payload: RefreshTokenRequest = { refreshToken };

  try {
    const { data } = await httpClient.post<RefreshTokenResponse>('/auth/refresh-token', payload);

    if (!data.success || !data.result) {
      throw new Error(data.message || 'Invalid or expired refresh token.');
    }

    return data.result;
  } catch (err) {
    if (axios.isAxiosError<RefreshTokenResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Invalid or expired refresh token.');
    }
    throw err;
  }
};